var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.927,
    cy: 20.7805,
    r: 20.7805,
    fill: "#BCBCBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.601 12H14.7828C13.8828 12 13.1465 12.7364 13.1465 13.6364V25.0909H14.7828V13.6364H24.601V12ZM27.0556 15.2727H18.0556C17.1556 15.2727 16.4192 16.0091 16.4192 16.9091V28.3636C16.4192 29.2636 17.1556 30 18.0556 30H27.0556C27.9556 30 28.6919 29.2636 28.6919 28.3636V16.9091C28.6919 16.0091 27.9556 15.2727 27.0556 15.2727ZM27.0556 28.3636H18.0556V16.9091H27.0556V28.3636Z",
    fill: "#F4F4F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a3a1d7e0b94ebfd234706aef71cee6be.svg";
export { ForwardRef as ReactComponent };